export enum DistributionChannel {
  Online = '001',
  Bancassurance = '002',
  Agency = '003',
  GroupInsuranceBusiness = '004',
}
